import 'slick-carousel/slick/slick';

$('.header-slider').slick({
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    appendArrows: ".header-slider-navigation",
    appendDots: ".header-slider-navigation .dots",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        },
      }
    ]
  });